var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Mount } from './Mount';
import { canUseEs6Features } from './util';
export var Es6Adapter = /** @class */ (function () {
    function Es6Adapter() {
    }
    return Es6Adapter;
}());
// We have to define this class rather awkwardly, because otherwise IE11 will cry.
// This can be migrated to a normal es6 class if we drop support for es5
if (canUseEs6Features()) {
    Es6Adapter = /** @class */ (function (_super) {
        __extends(class_1, _super);
        //@ts-ignore
        function class_1(app) {
            var _this = this;
            // We can't use super here, because otherwise typescript runs amok with our HTMLElement.
            // Because want to build the script for an es5 target. So we have to take stuff into our own hands
            // and reflect the html element and create a new "this" correctly. Sadly, typescript does not like,
            // that we are not calling super() anywhere (Hence the ts-ignore flood). Luckily we only have to do this
            // once, for this component.
            // @ts-ignore
            _this = Reflect.construct(HTMLElement, [], _this.__proto__.constructor);
            // @ts-ignore
            _this._bitMount = new Mount(app);
            // @ts-ignore
            return _this;
        }
        Object.defineProperty(class_1.prototype, "bit", {
            /**
             * Returns the instance of the bit or null if there is none currently active.
             */
            get: function () {
                return this._bitMount.bit;
            },
            enumerable: false,
            configurable: true
        });
        /**
         * Web-Component lifecycle hook
         * Invoked each time the custom element is appended into a document-connected element.
         * This will happen each time the node is moved, and may happen before the element's contents have been
         * fully parsed.
         */
        class_1.prototype.connectedCallback = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (!this.isConnected) {
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, this._bitMount.connect(this)];
                });
            });
        };
        /**
         * Web-Component lifecycle hook
         * Invoked each time the custom element is disconnected from the document's DOM.
         */
        class_1.prototype.disconnectedCallback = function () {
            this._bitMount.disconnect();
        };
        return class_1;
    }(HTMLElement));
}
//# sourceMappingURL=Es6Adapter.js.map